<template>
  <div>
    <!-- 功能栏 -->
    <div
      style="display: flex; align-items: center; justify-content: space-around"
      v-click-outside="closeBlock"
    >
      <ul class="toollist-container">
        <li v-for="(k, i) in toolList" :key="i" class="pointer" v-show="isShowTool(k)">
          <el-tooltip
            :content="$t('aside-left.需要获取主控权')"
            placement="top-start"
            v-if="avctl == 0 && (k.type == 4 || k.type == 7)"
          >
            <div class="toollist-disabled">
              <div class="toollist-icon">
                <img :src="k.iconDisable" />
              </div>
              <p class="tool-name enabled-color">
                {{ $t(`asideLeft.${k.name}`) }}
              </p>
            </div>
          </el-tooltip>
          <el-tooltip
            :content="$t('aside-left.需要获取演示权')"
            placement="top-start"
            v-else-if="share == 0 && k.type == 2"
          >
            <div class="toollist-disabled">
              <div class="toollist-icon">
                <img :src="k.iconDisable" />
              </div>
              <p class="tool-name">
                {{ $t(`asideLeft.${k.name}`) }}
              </p>
            </div>
          </el-tooltip>
          <div
            v-else-if="shareType == 4 && (k.type == 0 || k.type == 1 || k.type == 2 || k.type == 6)"
            class="toollist-disabled"
          >
            <div class="toollist-icon">
              <img :src="k.iconDisable" />
            </div>
            <p class="tool-name">
              {{ $t(`asideLeft.${k.name}`) }}
            </p>
          </div>
          <el-tooltip
            :content="$t('aside-left.视频源暂不支持')"
            placement="top-start"
            v-else-if="liveConfig.video_source_ratio && (k.type == 2 || k.type == 3 || k.type == 7)"
          >
            <div class="toollist-disabled">
              <div class="toollist-icon">
                <img :src="k.iconDisable" />
              </div>
              <p class="tool-name">
                {{ $t(`asideLeft.${k.name}`) }}
              </p>
            </div>
          </el-tooltip>
          <div v-else class="toollist-style1" @click="changeTool(k)">
            <img
              v-if="k.type === 6 && liveConfig.liveondemandVoiceStatus === 0 && shareType === 3"
              :src="k.iconMute"
              width="18"
              height="18"
              key="61"
              style="transform: scale(1.2, 1.35)"
            />
            <img
              v-else-if="k.type != 3 || (mediaStatus != 2 && mediaStatus != 3) || avctl == 0"
              :src="activeIcon == k.type ? k.iconActive : k.icon"
              width="18"
              height="18"
            />
            <img :src="require('@/assets/images/countDown/playing.png')" v-else /><span
              v-show="k.show && k.len"
              ><label class="lianmai-tips">{{ k.len }}</label></span
            >
            <p class="tool-name" :class="{ 'toollist-actve': activeIcon == k.type }">
              {{ $t(`asideLeft.${k.name}`) }}
            </p>
          </div>
        </li>
        <!--  连麦 -->
        <lianmai
          v-show="openLianMai"
          :isOpenLianMai="openLianMai"
          ref="lianmai"
          :lianmais.sync="lianmais"
        ></lianmai>
      </ul>
      <div class="bottom-container">
        <!--音频-->
        <audioContent />
        <!--视频-->
        <videoContent />
        <!-- 开启/结束直播 -->
        <div class="live dialog-dark" v-if="role == 3">
          <div v-if="avctl == 1">
            <el-popover
              placement="top-start"
              class="popover"
              width="250"
              trigger="manual"
              v-model="showStartInfo"
            >
              <div>
                <h4 class="fontColor">{{ $t('asideLeft.开始直播') }}</h4>
                <p style="margin: 10px 0px" class="fontColor">
                  {{ $t('asideLeft.startLiveTips') }}
                </p>
                <el-button type="primary" round size="mini" @click="showStartInfo = false">{{
                  $t('aside-left.我知道了')
                }}</el-button>
              </div>
              <el-button
                v-show="liveStartStatus !== 2"
                slot="reference"
                @click="starLiveOrEndliveFunc(0)"
                type="primary"
                round
                size="mini"
                class="blueBtn"
                >{{ $t('aside-left.开始') }}</el-button
              >
            </el-popover>
            <p v-show="liveStartStatus == 2" class="fontSize12 fontStyle" id="showLiveTime">
              {{ liveTime }}
            </p>
            <el-popover
              placement="top-start"
              popper-class="endlive-popover"
              class="popover endlive-popover"
              v-model="showEndLiveTips"
            >
              <div>
                <p style="margin: 10px 0px" class="fontColor">
                  {{ $t('aside-left.你确定要结束直播吗') }}
                </p>
                <el-button
                  class="cancel-btn-mini"
                  round
                  size="mini"
                  @click="showEndLiveTips = false"
                  >{{ $t('aside-left.取消') }}</el-button
                >
                <el-button @click="starLiveOrEndliveFunc(1)" type="primary" round size="mini">{{
                  $t('aside-left.确定')
                }}</el-button>
              </div>
              <el-button
                v-show="liveStartStatus == 2"
                slot="reference"
                type="danger"
                round
                size="mini"
                class="endBtn"
                >{{ $t('aside-left.结束') }}</el-button
              >
            </el-popover>
          </div>
          <div v-else class="enabled-start">
            <p v-show="liveStartStatus == 2" class="fontSize12 fontStyle" id="showLiveTime">
              {{ liveTime }}
            </p>
            <el-tooltip :content="$t('aside-left.需要获取主控权')" placement="top-start">
              <el-button
                v-if="liveStartStatus == 2"
                type="danger"
                round
                size="mini"
                class="endBtn"
                >{{ $t('aside-left.结束') }}</el-button
              >
              <el-button v-else round size="mini" class="blueBtn disabledBtn">{{
                $t('aside-left.开始')
              }}</el-button>
            </el-tooltip>
          </div>
        </div>
        <!-- 录制 v-if="avctl == 1"-->
        <div class="recording" v-if="avctl == 1">
          <div class="fontSize12 fontStyle">
            <!-- <el-popover
              placement="top"
              width="320"
              trigger="manual"
              v-model="recordInfo.showRecordTips"
            > -->
            <div class="record-tips" v-show="recordInfo.showRecordTips">
              <h4 class="fontColor">{{ $t('aside-left.录制提醒') }}</h4>
              <p style="margin: 10px 0px" class="fontColor">
                {{ $t('aside-left.是否立即开始录制') }}
              </p>
              <el-button  round size="mini" @click="noTipsRecord">{{
                $t('aside-left.不再提醒')
              }}</el-button>
              <el-button  round size="mini" @click="fiveMinsTips">{{
                $t('aside-left.分钟后再提醒')
              }}</el-button>
              <el-button type="primary" round size="mini" @click="setRecordStatusFunc(0)">{{
                $t('aside-left.开启录制')
              }}</el-button>
            </div>
            <div
              v-show="liveStartStatus == 2 && recordStatus != 0 && autoRecording == 2"
              slot="reference"
              class="record-icon"
              @click.stop="setRecordStatusFunc(0)"
            >
              <div class="red-dot"></div>

              <span v-if="loadingRecord">
                {{ $t('asideLeft.loading') }}
              </span>
              <span type="primary" v-else>{{ $t('asideLeft.未录制') }}</span>
            </div>
            <!-- </el-popover> -->
            <!-- liveStartStatus == 2 &&  -->
            <div
              class="end-record-tips"
              v-show="showEndTips && recordStatus == 0 && liveStartStatus == 2"
            >
              <p style="margin: 10px 0px; white-space: nowrap" class="fontColor">
                {{ $t('aside-left.你确定要结束录制吗') }}
              </p>
              <el-button class="cancel-btn-mini" round size="mini" @click="showEndTips = false">{{
                $t('aside-left.取消')
              }}</el-button>
              <el-button type="primary" round size="mini" @click="setRecordStatusFunc(1)">{{
                $t('aside-left.确定')
              }}</el-button>
            </div>
            <div
              slot="reference"
              class="recording-icon"
              v-show="recordStatus == 0 && liveStartStatus == 2 && !mouseHover"
              @mouseover="mouseover"
              @mouseleave="mouseout"
            >
              <div class="red-dot" :class="{ blink: isBlinking }"></div>
              <p
                type="primary"
                round
                size="mini"
                :class="{ red: recordStatus == 0 }"
                id="recording"
              >
                {{ recordingTime }}
              </p>
            </div>
            <div
              slot="reference"
              class="recording-end-icon"
              @click="stopRecording"
              v-show="recordStatus == 0 && liveStartStatus == 2 && mouseHover"
              @mouseover="mouseover"
              @mouseleave="mouseout"
            >
              {{ $t('aside-left.结束录制') }}
            </div>
            <div
              v-if="(recordStatus != 0 && autoRecording == 1) || liveStartStatus != 2"
              class="record-icon"
              @click="setRecordStatusFunc(0)"
            >
              <div class="red-dot"></div>
              <span v-if="loadingRecord" round size="mini">
                {{ $t('asideLeft.loading') }}
              </span>
              <span v-else>{{ $t('asideLeft.未录制') }}</span>
            </div>
          </div>
        </div>
        <div v-else-if="role == 3" class="recording">
          <el-tooltip :content="$t('aside-left.需要获取主控权')" placement="top-start">
            <div class="record-icon enabled-color enabled-record">
              <div class="red-dot"></div>
              <p type="primary" style="color: #727480" round size="mini" v-if="recordStatus != 0">
                {{ $t('asideLeft.未录制') }}
              </p>
              <span round size="mini" id="recording" :class="{ red: recordStatus == 0 }" v-else>
                {{ recordingTime }}
              </span>
            </div>
          </el-tooltip>
        </div>
      </div>
    </div>

    <!-- 设置弹框 -->
    <setting :visible.sync="openSetting" append-to-body />
    <!-- 布局设置 -->
    <layout :visible.sync="openLayout" append-to-body />
  </div>
</template>

<script>
import { getTheme, setImgOrSvg } from '@/utils/themeImg';
import icon0 from '@/svg/upload.svg';
import setting from '@/components/setting';
import layout from '@/components/layout';
import lianmai from '@/components/lianmai';
import videoContent from '@/components/local/videoContent';
import audioContent from '@/components/local/audioContent.vue';
import { addStreamStopListener, getParameter } from '@/utils/global';
import { setLiveState, setRecordStatus } from '@/api/liveRequest/liveInfo';
import { cloudInfo, cloudSwitch } from '@/api/docRequest/api';
import { getStreams } from '@/api/fetchMeet/api';
import {
  pushRoomControlFunc,
  pushRoomMessageFunc,
  removeMessageFunc
} from '@/utils/socketMessageDispose';
import Bus from '@/components/doc/bus';
import { Message } from 'element-ui';
import vClickOutside from 'v-click-outside';
import displayMediaError from '@/mixins/displayMediaError';
import { device } from '../../utils/global';
import { mapGetters } from 'vuex';
// import { getStreams } from "@/mixins/meet";
import { getLiveInfo } from '@/api/liveRequest/liveInfo';
export default {
  name: 'asideLeft',
  directives: {
    clickOutside: vClickOutside.directive
  },
  mixins: [displayMediaError],
  data() {
    return {
      icon0: icon0,
      toolList: [
        {
          name: '文档',
          type: 0,
          icon: require('@/svg/doc.svg'),
          iconActive: require('@/svg/doc_active.svg')
        },
        {
          name: '白板',
          type: 1,
          icon: require('@/svg/whiteboard.svg'),
          iconActive: require('@/svg/whiteboard_active.svg')
        },
        {
          name: '共享',
          type: 2,
          icon: require('@/svg/share.svg'),
          iconActive: require('@/svg/share_active.svg'),
          iconDisable: require('@/svg/share.svg')
        },
        {
          name: '多媒体',
          type: 3,
          icon: require('@/svg/multimedia.svg'),
          iconActive: require('@/svg/multimedia_active.svg'),
          iconDisable: require('@/svg/multimedia.svg')
        },
        // {
        //   name: this.$t("asideLeft.伪直播"),
        //   type: 4,
        //   icon: require("@/svg/doc.svg"),
        // },
        {
          name: '工具',
          type: 5,
          icon: require('@/svg/tool.svg'),
          iconActive: require('@/svg/tool_active.svg')
        },
        {
          name: '连麦',
          type: 6,
          icon: require('@/svg/lianmai.svg'),
          iconActive: require('@/svg/lianmai_active.svg'),
          iconMute: require('@/svg/lianmai_mute.svg')
        },
        {
          name: '布局',
          type: 7,
          icon: require('@/svg/layout.svg'),
          iconActive: require('@/svg/layout_active.svg'),
          iconDisable: require('@/svg/layout.svg'),
          tooltip: false
        },
        {
          name: '分组控制',
          type: 8,
          icon: require('@/svg/group/group.svg'),
          iconActive: require('@/svg/group/group.svg'),
          iconDisable: require('@/svg/group/group.svg'),
          tooltip: false
        }
      ],
      openSetting: false,
      openLianMai: false,
      openLayout: false,
      recordingLock: false,
      recordTimeIntervel: null,
      showAnswer: false,
      showAnswerSheet: false,
      roomId: getParameter('roomId'),
      showStartInfo: false,
      recordInfo: {
        timer: null,
        showRecordTips: false
      },
      showEndTips: false,
      liveTimers: null,
      liveComputedTime: null,
      showEndLiveTips: false,
      isStop: false, //是否调结束直播接口成功
      isInit: false,
      recordLink: false,
      activeIcon: 0, // 加点击后状态，2.1
      loadingRecord: false,
      lianmais: 0,
      isCB: false, // 是否插播
      recordTimers: null,
      tk: null,
      changeBirate: false,
      liveTime: '',
      recordingTime: '',
      isBlinking: true,
      mouseHover: false //鼠标是否移到开始时间上
    };
  },
  components: {
    setting,
    lianmai,
    layout,
    videoContent,
    audioContent
  },
  beforeDestroy() {
    Bus.$off('showStartTips');
    Bus.$off('closeShare');
    Bus.$off('systemMsg');
    // if (this.liveTimers) {
    //   clearInterval(this.liveTimers);
    //   this.liveTimers = null;
    // }
    removeMessageFunc(this.getCvMcRoomMessage);
    removeMessageFunc(this.getCvMcRoomControl);
    this.tk && this.tk.postMessage({ status: 'endRecord' });
    this.tk && this.tk.postMessage({ status: 'endLive' });
    this.tk && this.tk.postMessage({ status: 'end' });
  },
  watch: {
    sid: {
      immediate: true,
      handler(n) {
        if (n) {
          this.getCloudShare();
        }
      }
    },
    share(n, o) {
      this.changeShare(n, o);
      if (n == 0) {
        this.closePublishShare();
      }
    },
    role(val) {
      if (val !== 3) {
        this.openSetting = false;
        this.openLayout = false;
        this.openLianMai = false;
      } else {
        if (this.liveStartStatus == 2 && val == 3 && this.avctl != 1) {
          this.setLiveTime();
        }
      }
    },
    avctl: {
      immediate: true,
      handler(val) {
        this.$nextTick(() => {
          this.changeRecordTips();
          this.changeShowStartTips();
        });
        if (val && this.liveStartStatus == 2 && this.role == 3) {
          console.log('avctl 改变修改时间。。。');
          this.setLiveTime();
          this.showStartInfo = false;
        }
      }
    },
    // 直播结束
    liveStartStatus: {
      immediate: true,
      handler(n) {
        if (n != 2) {
          //  停止录制计时
          //clearTimeout(this.recordInfo.timer);
          //this.recordInfo.timer = null;
          this.recordInfo.showRecordTips = false;
          // if (this.liveTimers) {
          //   clearInterval(this.liveTimers);
          //   this.liveTimers = null;
          // }
          if (this.isInit) {
            this.changeShowStartTips();
          }
        } else {
          // this.$store.commit("SET_LIVESTARTTIME",new Date().getTime())
          if (this.role == 3) {
            console.log('直播状态改变修改时间。。。');
            this.setLiveTime();
          }
          if (!this.$store.getters.firstInit) {
            this.$message.success(this.$t('aside-left.直播开始了'));
          }
          //Bus.$emit("systemMsg", this.$t('aside-left.直播开始了'));
          Bus.$emit('systemMsg', {
            text: '直播开始了'
          });
          this.showStartInfo = false;
          if (this.isStop) return;
          setTimeout(() => {
            this.changeRecordTips();
          }, 1000);
        }
      }
    },
    // 录制状态发生改变
    recordStatus: {
      immediate: true,
      handler: function (value) {
        if (value == 0) {
          this.$nextTick(() => {
            console.log('录制状态改变修改时间。。。');
            this.setRecordTime();
          });
        } else {
          this.tk && this.tk.postMessage({ status: 'endRecord' });
          this.$store.commit('SET_RECORD_START_TIME', -1);
        }
      }
    },
    liveStartTime: {
      immediate: true,
      handler: function () {
        if (this.liveStartStatus == 2 && this.role == 3) {
          this.$nextTick(() => {
            console.log('开始时间改变修改时间。。。');
            this.setLiveTime();
          });
        }
      }
    },
    leftToolType: {
      immediate: true,
      handler: function (value) {
        this.activeIcon = value;
      }
    },
    settingShow: {
      immediate: true,
      handler: function (value) {
        this.openSetting = value;
      }
    },
    lianmais: {
      immediate: true,
      handler: function (value) {
        console.log(value, 'openLianMai');
        if (value > 0) {
          this.toolList[5].len = value > 99 ? '99+' : value;
          if (!this.openLianMai) {
            this.toolList[5].show = true;
          } else {
            this.toolList[5].show = false;
          }
        } else {
          delete this.toolList[5].len;
        }
        this.$forceUpdate();
      }
    },
    openLianMai: {
      immediate: true,
      handler: function (value) {
        console.log(value, '显示连麦');
        if (!value) {
          this.toolList[5].show = true;
        } else {
          this.toolList[5].show = false;
        }
        this.$forceUpdate();
      }
    },
    language: {
      immediate: true,
      handler(n) {
        console.log(n, 'value');
        this.$i18n.locale = n;
        this.$root.$i18n.locale = n;
      }
    },
    isSystemJoinVoip: {
      immediate: true,
      handler(n) {
        if (n == 1) {
          this.openLianMai = false;
          this.toolList = this.toolList.filter((n) => {
            return n.type != 6;
          });
        }
      }
    }
  },
  computed: {
    ...mapGetters(['liveConfig', 'userInfo', 'language', 'recordStartTime', 'meetStatusInfo']),
    settingShow() {
      return this.$store.getters.setting;
    },
    sid() {
      return this.$store.getters.sid;
    },
    rtcClient() {
      return this.$store.getters.rtcClient;
    },
    liveStartStatus() {
      return this.$store.getters.liveRoomStatus;
    },
    liveId() {
      return this.$store.getters.liveId;
    },
    liveToken() {
      return this.$store.getters.liveToken;
    },
    recordStatus() {
      return this.$store.getters.recordStatus;
    },
    audioStatus() {
      return this.$store.getters.selfParticipant && this.$store.getters.selfParticipant.mediaStatus
        ? this.$store.getters.selfParticipant.mediaStatus.audio
        : 'disabled';
    },
    role() {
      //3:主播 2：助手 1：嘉宾
      return this.$store.getters.selfParticipant && this.$store.getters.selfParticipant.type;
    },
    share() {
      //演示权
      return this.$store.getters.selfParticipant && this.$store.getters.selfParticipant.share;
    },
    // 主控权   1：有  0：无
    avctl() {
      return this.$store.getters.selfParticipant && this.$store.getters.selfParticipant.avctl;
    },
    isShowTool() {
      console.log(this.liveConfig.is_group, 'this.liveConfig.is_group');
      return (info) => {
        return (this.role != 3 &&
          (info.type == 4 ||
            (info.type == 6 && this.liveStartStatus != 2) ||
            info.type == 7 ||
            (info.type == 5 && !this.share))) ||
          (info.type == 8 && !this.liveConfig.is_group)
          ? false
          : true;
      };
    },
    leftToolType() {
      return this.$store.getters.leftToolType;
    },
    liveStartTime() {
      return this.$store.getters.liveStartTime;
    },
    /**
     * 共享类型 0 文档 1 白板 2 桌面共享 3 插播 4 伪直播
     */
    shareType() {
      return this.$store.getters.shareType;
    },
    // thirdPushStreamStatus() {
    //   return this.$store.getters.thirdPushStreamStatus;
    // },
    autoRecording() {
      return this.$store.getters.autoRecording; //是否开启自动录制： 1-打开 2关闭
    },
    joinedList() {
      return this.$store.getters.JoinedList;
    },
    mediaStatus() {
      return this.$store.getters.mediaStatus;
    },
    // 是否有连麦权限
    isSystemJoinVoip() {
      return this.$store.getters.voipInfo?.isSystemJoinVoip;
    },
    firstInit() {
      return this.$store.getters.firstInit;
    }
  },
  created() {
    this.loadWorker();
    console.log('created left');
    pushRoomMessageFunc(this.getCvMcRoomMessage);
    pushRoomControlFunc(this.getCvMcRoomControl);
  },
  mounted() {
    this.toolList = getTheme(this.toolList);
    this.initLeft();
  },
  methods: {
    mouseover() {
      this.mouseHover = true;
    },
    mouseout() {
      this.mouseHover = false;
    },
    loadWorker() {
      let baseUrl =
        process.env.NODE_ENV === 'production' ||
        process.env.NODE_ENV === 'dev' ||
        process.env.NODE_ENV === 'test'
          ? '/cla/'
          : '/';
      this.tk = new Worker(`${baseUrl}webworker.js`);
      console.log(this.tk, '加载worker');
      //this.tk.postMessage({ status: 'initRecord' });
      this.tk.onmessage = (info) => {
        const { event } = info.data;
        // console.log(event, "event");
        if (event == 'startLive') {
          const liveTime = this.getLiveTime();
          this.liveTime = liveTime;
        }
        if (event == 'record') {
          const time = this.getRecordTime();
          this.recordingTime = time;
        }
      };
    },
    stopRecording() {
      console.log('触发点击');
      this.showEndTips = true;
    },
    closeBlock() {
      this.activeIcon = this.leftToolType;
      this.$store.commit('SET_SHOW_ASIDE_TOOL', false);
    },
    setLiveTime() {
      // if (this.liveTimers) {
      //   clearInterval(this.liveTimers);
      //   this.liveTimers = null;
      // }
      // this.liveTimers = setInterval(() => {
      //   this.liveTime = this.getLiveTime();
      // }, 1000);
      this.tk && this.tk.postMessage({ status: 'endLive' });
      this.tk && this.tk.postMessage({ status: 'startLive' });
      this.liveTime = this.getLiveTime();
    },
    setRecordTime() {
      console.log(this.tk, 'this.tk');
      this.tk && this.tk.postMessage({ status: 'endRecord' });
      this.tk && this.tk.postMessage({ status: 'startRecord' });
      this.recordingTime = this.getRecordTime();
    },
    getLiveTime() {
      if (this.liveStartTime == -1) {
        let liveStartTime = new Date().getTime() / 1000;
        this.$store.commit('SET_LIVESTARTTIME', liveStartTime);
      }
      return this.getTime(this.liveStartTime);
    },
    getRecordTime() {
      if (this.recordStartTime == -1) {
        let recordStartTime = new Date().getTime() / 1000;
        this.$store.commit('SET_RECORD_START_TIME', recordStartTime);
      }
      return this.getTime(this.recordStartTime);
    },
    getTime(time) {
      const seconds = Math.floor((new Date().getTime() - time * 1000) / 1000);
      var hour = parseInt(seconds / 3600);
      var minutes = parseInt((seconds - hour * 3600) / 60);
      var second = parseInt(seconds % 60);
      hour = hour < 10 ? `0${hour}` : hour;
      minutes = minutes < 10 ? `0${minutes}` : minutes;
      second = second < 10 ? `0${second}` : second;
      return hour + ':' + minutes + ':' + second;
    },
    initLeft() {
      this.isInit = true;
      Bus.$on('changeTheme', (val) => {
        this.toolList = getTheme(this.toolList);
        setImgOrSvg(val);
      });
      Bus.$on('closeShare', () => {
        this.closePublishShare();
      });
      Bus.$on('showStartTips', () => {
        this.changeShowStartTips();
      });
      Bus.$on('openSetting', () => {
        this.openSetting = true;
      });

      this.$nextTick(() => {
        // if(this.role == 3 && this.avctl && this.liveStartStatus == 2 && this.recordStatus !== 0){
        //   this.fiveMinsTips();
        // }
        // if (this.liveStartStatus == 2 && this.role == 3) {
        //   this.setLiveTime();
        // }
        if (this.autoRecording == 1) return;
        if (this.liveStartStatus == 2 && this.recordStatus == 1) {
          setTimeout(() => {
            this.recordInfo.showRecordTips = true;
          }, 1000);
          //this.fiveMinsTips();
        }
      });
    },
    // 不在提醒录制
    noTipsRecord() {
      this.recordInfo.showRecordTips = false;
      clearTimeout(this.recordInfo.timer);
      this.recordInfo.timer = null;
      this.logger.info({ code: 2013, message: this.userInfo });
    },
    // 3分钟后提醒
    fiveMinsTips() {
      if (this.recordStatus == 0) {
        return;
      }
      clearTimeout(this.recordInfo.timer);
      this.recordInfo.timer = null;
      this.recordInfo.showRecordTips = false;
      this.recordInfo.timer = setTimeout(() => {
        this.recordInfo.showRecordTips = true;
      }, 180000);
      this.logger.info({ code: 2014, message: this.userInfo });
    },
    changeShowStartTips() {
      if (this.liveStartStatus != 2 && this.avctl) {
        console.log('---------showStartInfo');
        this.showStartInfo = true;
      } else {
        this.showStartInfo = false;
      }
    },
    changeRecordTips() {
      if (
        this.autoRecording == 2 &&
        this.avctl &&
        this.liveStartStatus == 2 &&
        this.recordStatus != 0
      ) {
        this.recordInfo.showRecordTips = true;
      } else {
        this.recordInfo.showRecordTips = false;
      }
    },
    changeTool(key) {
      let type = key.type;
      this.activeIcon = type;
      if (
        (this.shareType == 4 && (type == 0 || type == 1 || type == 2 || type == 6)) ||
        (this.liveConfig.video_source_ratio && (type == 2 || type == 3 || type == 7))
      )
        return;
      if (this.thirdPushStreamStatus && type == 6) return;
      // 共享桌面
      if (type === 0) {
        if (this.leftToolType === 0) return;
        this.cloudSwitch('doc', 0);
      } else if (type === 1) {
        if (this.leftToolType === 1) return;
        this.cloudSwitch('wb', 1);
      } else if (type == 2) {
        if (this.avctl == 1 && this.share == 0 && type == 2) return;
        if (
          this.rtcClient.RTCRoom.shareStream &&
          this.rtcClient.RTCRoom.shareStream.type == 'streaming'
        ) {
          this.$message.error(this.$t('aside-left.当前正在播放多媒体'));
          return;
        }
        if (
          this.rtcClient.RTCRoom.shareStream &&
          this.rtcClient.RTCRoom.shareStream.type == 'webrtc'
        ) {
          this.$message.error(this.$t('aside-left.当前正在共享桌面'));
          return;
        }
        if (this.share == 1) {
          let config = {
            audio: true,
            video: {
              source: 'screen-cast',
              frameRate: 15,
              resolution: {
                width: 1920,
                height: 1080
              }
            }
          };
          // this.startCapture();
          if ((device().isSafari && device().isSafari[1].split('.')[0] < 13) || device().isIE) {
            this.$message.error(this.$t('aside-left.您的浏览器不支持使用桌面共享功能'));
            return;
          }

          this.rtcClient.RTCRoom.publishShareScreen(config)
            .then((res) => {
              console.log(res, '返回共享.....');
              //TODO 判断改流
              this.layoutStreams();
              this.$store.commit('SET_SHARE_TYPE', 2);
              if (res.stream && res.stream.id) {
                Bus.$emit('startShare');
                addStreamStopListener(res.stream, () => {
                  console.log('分辨率stream .....', res.stream);
                  this.closePublishShare();
                  //Bus.$emit("closeShare");
                });
                ['ended', 'error'].forEach((i) => {
                  console.log('分辨率 ended......');
                  res.publication.addEventListener(i, () => {
                    this.closePublishShare();
                    //Bus.$emit("closeShare");
                  });
                });
                this.getDisplayMediaError('success');
              } else {
                console.log(res.stream.info.name, 'res.info.name');
              }
              this.logger.info({ code: 2057, message: res });
            })
            .catch((error) => {
              console.log(error, '捕获共享错误');
              this.$message.error(this.$t('aside-left.您的浏览器不支持使用桌面共享功能'));
            });
        } else {
          this.$message.error(this.$t('aside-left.没有演示权不能共享'));
        }
      } else if (type == 3) {
        // 多媒体
        this.$store.commit('SET_SHOW_INCURT', true);
      } else if (type == 4) {
        if (this.avctl == 0) return;
        // 伪直播
        this.$store.commit('SET_SHOW_PSEUDO', true);
      } else if (type == 6) {
        this.openLianMai = !this.openLianMai;
        this.$store.commit('SET_SHOW_ASIDE_TOOL', false);
      } else if (type == 7) {
        if (this.avctl == 0) return;
        this.openLayout = true;
      } else if (type == 5) {
        //this.openLianMai = false;
        this.$store.commit('SET_SHOW_ASIDE_TOOL', true);
      } else if (type == 8) {
        //this.openGroup = true;
        this.$store.commit('SET_SHOW_GROUP', true);
      } else {
        this.$store.commit('SET_LEFTTOOLTYPE', type);
      }
    },
    closePublishShare() {
      console.log('关闭共享');
      this.rtcClient.RTCRoom.unPublishShareScreen();
      if (
        this.rtcClient.RTCRoom.webrtc.publishShare.shareStream &&
        this.rtcClient.RTCRoom.webrtc.publishShare.shareStream.getTracks
      ) {
        this.rtcClient.RTCRoom.webrtc.publishShare.shareStream.getTracks().forEach((track) => {
          track.stop();
        });
      }
    },
    /**
     * 判断自己是否在混流中，不在的话降发送分辨率为360P
     */
    //TODO 获取流
    async layoutStreams() {
      const sessionToken = this.meetStatusInfo.joinRoomRes.sessionToken;
      const url = this.rtcClient.rtServerUrl.meetUrl;
      const roomId = this.meetStatusInfo.roomId;
      console.log(this.meetStatusInfo, 'this.meetStatusInfo...');
      console.log(this.rtcClient, 'this.rtcClient...');
      const isCurrentStreams = sessionStorage.getItem('selfStreamId');
      console.log(isCurrentStreams, 'isCurrentStreams....');
      // debugger;
      const { status, data } = await getStreams(roomId, url, sessionToken);
      let selfInLayout = true;
      console.log(data, 'data.....');
      if (status === 200) {
        if (data.includes(isCurrentStreams)) {
          selfInLayout = true;
        } else {
          Bus.$emit('scaleBitrate', true);
          this.changeBirate = true;
          selfInLayout = false;
        }
      }
      return selfInLayout;
    },
    /***
     * 获取屏幕实验
     */
    // async startCapture() {
    //   let captureStream = null;
    //   console.log(".....................");
    //   try {
    //     captureStream = await navigator.mediaDevices.getDisplayMedia();
    //     console.log(captureStream, "ddddddddddddddddddddddddd");
    //   } catch (err) {
    //     console.error("Error: ", err.name);
    //   }
    //   return captureStream;
    // },
    getCvMcRoomMessage(msg) {
      switch (msg.cmd) {
        case 7107: {
          this.disposeCustomMessage_7107(msg.requestData);
          break;
        }
        case 7125: {
          // this.disposeCustomMessage_7125(msg.requestData);
          break;
        }
        case 7127: {
          this.disposeCustomMessage_7127(msg.requestData);
        }
      }
    },
    getCvMcRoomControl() {},
    getLiveInfo() {
      getLiveInfo(this.liveId).then((res) => {
        if (res && res.code == 200 &&  res.data && res.data.confStartTime) {
          this.$store.commit('SET_LIVESTARTTIME',  res.data.confStartTime);
        } else {
          if (this.liveStartTime == -1) {
              let liveStartTime = new Date().getTime() / 1000;
              this.$store.commit('SET_LIVESTARTTIME', liveStartTime);
            }
        }
      });
    },
    /**处理7107消息内容体 */
    disposeCustomMessage_7107(requestData) {
      if (requestData.event) {
        switch (requestData.event) {
          case 'audience_main_layout': {
            // 56983 【文档视频切换同步】开启跟随切换后，嘉宾应该不跟随切换
            // 2022/8/16 修改为演示权用户切，无演示权不跟随切换
            if (this.share) {
              this.$store.commit(
                'SET_ISCHANGEAREA',
                `${requestData.status}` === '0' ? true : false
              );
            }
            break;
          }
          case 'liveStatus': {
            if (requestData.live && requestData.live.confId) {
              this.$store.commit('SET_CONF_ID', requestData.live.confId);
            }
            this.$store.commit('SET_LIVEROOMSTATUS', requestData.type);
            this.getLiveInfo()
            break;
          }
          case 'settingChange': {
            let curliveConfig = this.$store.state.liveInfo.liveConfig;
            console.log(curliveConfig);
            for (let key in requestData) {
              curliveConfig[key] = requestData[key];
            }
            this.$store.commit('SET_LIVECONFIG', curliveConfig);
            break;
          }
          case 'cloud_webcast_share_data': {
            const isNotDisturb = this.$store.state.defaultInfo.isNotDisturb;
            if (this.share === 0 && isNotDisturb === 'false') return;
            if (requestData.type === 'wb') {
              this.$store.commit('SET_LEFTTOOLTYPE', 1);
            } else {
              this.$store.commit('SET_LEFTTOOLTYPE', 0);
            }
            break;
          }
          case 'voip_is_join_status': {
            let voipInfo = this.$store.getters.voipInfo;
            this.$store.commit(
              'SET_VOIPINFO',
              Object.assign(voipInfo, {
                isJoinVoip: requestData.isJoinVoip,
                isSystemJoinVoip: requestData.isSystemJoinVoip,
                isJoinVideo: requestData.isJoinVideo
              })
            );
            // const tipsContent =
            //   requestData.isJoinVoip == 1
            //     ? this.$t("aside-left.直播间连麦已禁用")
            //     : this.$t("aside-left.直播间连麦已开放");
            // this.$message.success(`${tipsContent}`);
            Bus.$emit('voipStatus', requestData.isJoinVoip);
            const emitContet =
              requestData.isJoinVoip == 1 ? '直播间连麦已禁用' : '直播间连麦已开放';
            Bus.$emit('systemMsg', {
              text: emitContet
            });
            break;
          }
          case 'voip_is_update_status': {
            let voipInfo = this.$store.getters.voipInfo;
            this.$store.commit(
              'SET_VOIPINFO',
              Object.assign(voipInfo, {
                isJoinVideo: requestData.isJoinVideo
              })
            );

            const tipsContent =
              requestData.isJoinVideo == 1
                ? this.$t('aside-left.音视频连线已关闭')
                : this.$t('aside-left.音视频连线开启成功');
            this.$message.success(`${tipsContent}`);
            break;
          }
          case 'assistant_user_join_leave_state': {
            let userMsg =
              (requestData && requestData.message && JSON.parse(requestData.message)) ||
              requestData;
            if (userMsg && userMsg.role == 5) return;
            if (userMsg.status == 'join' || userMsg.status == 'leave') {
              // let role =
              //   userMsg.role == 6
              //     ? this.$t('aside-left.主播')
              //     : userMsg.role == 8
              //     ? this.$t('aside-left.助手')
              //     : this.$t('aside-left.嘉宾');
              if (userMsg.status == 'join') {
                let curJoineer = this.joinedList.find((info) => {
                  return info.uid == userMsg.userId;
                });
                if (curJoineer) {
                  curJoineer.name = userMsg.nickName;
                  if (curJoineer.type === 3) {
                    if (curJoineer.avctl == 1) {
                      if (!this.firstInit) {
                        this.$message.success(
                          `${this.$t('aside-right.主播')}_${userMsg.nickName}${this.$t(
                            'aside-right.成为了管理员'
                          )}`
                        );
                      }
                      Bus.$emit('systemMsg', {
                        role: '主播',
                        name: userMsg.nickName,
                        text: '成为了管理员'
                      });
                    }
                    if (curJoineer.share == 1) {
                      if (!this.firstInit) {
                        setTimeout(() => {
                          this.$message.success(
                          `${this.$t('aside-right.主播')}_${userMsg.nickName}${this.$t(
                            'aside-right.正在演示'
                          )}`
                        );
                        }, 300);

                      }
                      Bus.$emit('systemMsg', {
                        role: '主播',
                        name: userMsg.nickName,
                        text: '正在演示'
                      });
                    }
                  }
                }
              }
              // let status = userMsg.status == "join" ? "进来了" : "离开了";

              // Bus.$emit("systemMsg", `【${role}${userMsg.nickName}】${status}`);
              // this.$message.success(`【${role}${userMsg.nickName}】${status}`);
            }
            break;
          }
          case 'redpacketEvent': {
            if (requestData.type == 'send') {
              const typeInfo =
                requestData.entity.type == 0
                  ? this.$t('redpacket.normal')
                  : requestData.entity.type == 1
                  ? this.$t('redpacket.passwd')
                  : this.$t('redpacket.redPacketRain');
              Bus.$emit('systemMsg', {
                name: requestData.entity.userName,
                text: `${this.$t('redpacket.de')}${typeInfo}${this.$t('redpacket.sending')}`
              });
              this.$message.success(
                `${requestData.entity.userName}${this.$t('redpacket.de')}${typeInfo}${this.$t(
                  'redpacket.sending'
                )}`
              );
            }
            break;
          }
        }
      }
      // if (requestData.cmd === "6001") {
      //   if (requestData.action === "play") {
      //     let curliveConfig = this.$store.state.liveInfo.liveConfig;
      //     if (curliveConfig.liveondemandVoiceStatus === 0 && this.audioStatus == "active") {
      //       if (!this.isCB) {
      //         this.$message.error(this.$t('lianmai.插播全员静音中'))
      //       }
      //       this.isCB = true
      //     }
      //   }
      //   if (requestData.action === "stop") {
      //     this.$store.commit("SET_MEDIASTATUS", -1)
      //     this.isCB = false
      //   }
      // }
      this.logger.info({ code: 2015, message: JSON.stringify(requestData) });
    },
    /**处理7125消息内容体 对角色 */
    disposeCustomMessage_7127(requestData) {
      if (requestData.event && requestData.event == 'monitor_recordStart') {
        console.log(requestData.status, '录制状态变化7127发');
        //如果录制开启，改变准备中值为false
        if (requestData.status === 0) {
          this.loadingRecord = false;
          if (requestData.duration != undefined) {
            this.$store.commit(
              'SET_RECORD_START_TIME',
              requestData.duration ? new Date().getTime() / 1000 - requestData.duration / 1000 : -1
            );
          }
        }
        this.$store.commit('SET_RECORDSTATUS', requestData.status);
      }
      if (requestData.event && requestData.event == 'liveondemand_voice_enable_change') {
        let curliveConfig = this.$store.state.liveInfo.liveConfig;
        curliveConfig.liveondemandVoiceStatus = requestData.status;
        this.$store.commit('SET_LIVECONFIG', curliveConfig);
      }
      if (requestData.event && requestData.event == 'TO_BE_MAIN_CONTROL') {
        if (requestData.role === 'host') {
          if (requestData.uid !== this.userInfo?.uid) {
            //this.tk && this.tk.postMessage({ status: 'endRecord' });
            //this.tk && this.tk.postMessage({ status: 'endLive' });
            // if (this.liveTimers) {
            //   clearInterval(this.liveTimers);
            //   this.liveTimers = null;
            // }
            // if(this.recordTimers){
            //   clearInterval(this.recordTimers);
            //   this.recordTimers = null
            // }
          }
        }
      }
      if (requestData.event && requestData.event == 'assistant_user_join_leave_state') {
        let userMsg =
          (requestData && requestData.message && JSON.parse(requestData.message)) || requestData;
        if (userMsg && userMsg.role == 5) return;
        // if (userMsg.status == "join" || userMsg.status == "leave") {
        //   let role =
        //     userMsg.role == 6 ? "主播" : userMsg.role == 8 ? "助手" : "嘉宾";
        //   let status = userMsg.status == "join" ? "进来了" : "离开了";
        //   this.$message.success(`【${role}${userMsg.nickName}】${status}`);
        //   Bus.$emit("systemMsg", `【${role}${userMsg.nickName}】${status}`);
        // }
        if (userMsg.status == 'remove') {
          this.$message.success(`${userMsg.nickName}${this.$t('aside-left.用户被请出直播间')}`);
          Bus.$emit('systemMsg', {
            name: userMsg.nickName,
            text: '用户被请出直播间'
          });
        }
      }
      this.logger.info({ code: 2016, message: JSON.stringify(requestData) });
    },
    // 验证合同是否有效
    async getContract() {
      const data = await this.$store.dispatch('GET_CONTRACT');
      if (!data) return false;
      if (data.live_contract_status !== 1) {
        Message({
          message: this.$t('aside-left.服务已停用'),
          type: 'error',
          duration: 0
        });
        return false;
      }
      return true;
    },
    // 直播开启关闭相关
    async starLiveOrEndliveFunc(start) {
      this.showStartInfo = false;
      if (this.liveStartStatus !== 2) {
        const canNext = await this.getContract();
        if (!canNext) {
          return;
        }
      }
      if (this.autoRecording === 1 && !start) {
        this.loadingRecord = true;
      }
      setTimeout(() => {
        this.loadingRecord = false;
      }, 30000);
      this.setLiveStateFunc();
    },

    /** 设置当前直播间状态是否开启直播 */
    setLiveStateFunc() {
      let fromDataVal = new FormData();
      fromDataVal.append('webcastId', this.liveId);
      fromDataVal.append('state', this.liveStartStatus === 2 ? 1 : 0);
      const liveStatus = this.liveStartStatus;
      if (this.liveStartStatus === 2) {
        this.isStop = true;
      }
      setLiveState(fromDataVal, this.liveId, this.liveToken)
        .then((res) => {
          //console.log(res, "res9999999999999999999");
          if (liveStatus === 3) {
            this.$message.success(this.$t('aside-left.回放已关闭'));
          }
          if (res.data > 0) {
            this.$store.commit('SET_CONF_ID', res.data);
          }
          console.log(res, 'setLiveStateFunc');
        })
        .catch((err) => {
          if (fromDataVal == 0) {
            this.$message.error(this.$t('aside-left.视频源加载失败'));
          }
          console.log(err, 'err_setLiveStateFunc');
        });
    },
    // 录制相关
    /**
     * 设置录制状态
     */
    setRecordStatusFunc(status) {
      /**如果是准备中，不能点击 */
      if (this.loadingRecord) {
        return;
      }
      if (this.liveStartStatus != 2) {
        this.$message.warning(this.$t('aside-left.请先开启直播'));
        return;
      }
      this.recordingLock = true;
      this.$store.commit('SET_RECORDSTATUS', 2);
      if (status === 0) {
        console.log('显示准备中了......setRecordStatusFunc');
        this.recordInfo.showRecordTips = false;
        this.loadingRecord = true;
        clearTimeout(this.recordInfo.timer);
      }
      if (status === 1) {
        this.showEndTips = false;
      }
      setRecordStatus(
        {
          webcastId: this.liveId,
          status: status
        },
        this.liveToken
      )
        .then(({ code, msg }) => {
          this.recordingLock = false;
          //this.loadingRecord = false;
          console.log(code, 'res_setRecordStatus');
          if (code === 200) {
            if (status === 0) {
              this.$message({
                message: this.$t('aside-left.录制已开始'),
                type: 'success'
              });
              // this.setRecordSetTimeout();
            } else {
              this.finishRecordVisible = false;
              this.$message({
                message: this.$t('aside-left.录制已结束'),
                type: 'warning'
              });
              this.fiveMinsTips();
            }
          } else if (code === 2019) {
            this.$message({
              message: this.$t('aside-left.录制已开始'),
              type: 'success'
            });
            this.$alert(this.$t('aside-left.您的账号存储空间已经不足'), {
              title: this.$t('aside-left.提示'),
              customClass: 'tip-alert text-left',
              confirmButtonText: this.$t('aside-left.我知道了')
            });
          } else {
            this.$message.warning(msg);
          }
        })
        .catch((err) => {
          this.loadingRecord = false;
          this.recordingLock = false;
          console.log(err, 'err_setRecordStatus');
        });
      this.logger.info({ code: 2017, message: this.userInfo });
    },
    // 录制超时
    setRecordSetTimeout() {
      var recordTime = 0;
      this.clearRecordSetTimeout();
      this.recordTimeIntervel = setInterval(() => {
        recordTime++;
        if (recordTime == 10) {
          this.$store.commit('SET_RECORDSTATUS', null);
          this.clearRecordSetTimeout();
        }
        console.log(recordTime);
        console.log('录制等待时间');
      }, 1000);
    },
    clearRecordSetTimeout() {
      clearInterval(this.recordTimeIntervel);
      this.recordTimeIntervel = null;
    },
    // 演示权变化更新共享内容
    changeShare(val, oval) {
      console.warn(val, oval);
      if (oval !== null && val) {
        this.$nextTick(() => {
          if (this.leftToolType === 0) {
            this.cloudSwitch('doc', 0);
          } else if (this.leftToolType === 1) {
            this.cloudSwitch('wb', 1);
          }
        });
      }
    },
    // 获取当前共享项
    async getCloudShare() {
      console.log('getCloudShare');
      const { status, data } = await cloudInfo(this.roomId);
      if (status === 0) {
        if (data === 'wb') {
          this.$store.commit('SET_LEFTTOOLTYPE', 1);
        }
      }
    },
    // 共享项切换
    async cloudSwitch(name, type) {
      if (!this.share) {
        this.$store.commit('SET_LEFTTOOLTYPE', type);
        return;
      }
      const { status, message } = await cloudSwitch({
        roomId: this.roomId,
        type: name
      });
      if (status === 0) {
        this.$store.commit('SET_LEFTTOOLTYPE', type);
      }
      // 切换已是切换共享内容
      else if (status !== 2463) {
        this.$message.error(message);
      } else {
        this.$store.commit('SET_LEFTTOOLTYPE', type);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.toollist-container {
  margin-top: 20px;
  position: relative;

  .toollist-actve {
    // color: $bule-color !important;
  }

  > li {
    height: 40px;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 19px;
    position: relative;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .tool-name {
    color: $grey5-color;
    font-size: 12px;
  }

  .enabled-color {
    color: #44454d;
  }
}

.bottom-container {
  position: absolute;
  bottom: 0px;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: flex-end;
  width: 80px;

  .fontStyle {
    color: $grey3-color;
    line-height: 20px;
  }

  .setting {
    padding-bottom: 31px;
    cursor: pointer;
  }

  .recording {
    padding: 19px 0 26px 0;
  }
}

.recording-icon {
  overflow: hidden;
  cursor: pointer;
  font-size: 12px;
  width: 66px;
  border-radius: 14px;
  border: 1px solid #acb2bf;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  // img {
  //   filter: drop-shadow(#ea494b 80px 0);
  //   -webkit-filter: drop-shadow(#ea494b 80px 0);
  //   transform: translateX(-80px);
  // }
  .red-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #ff7257;
    margin-right: 4px;
  }

  .blink {
    animation: fade 0.8s infinite;
  }

  @keyframes fade {
    0% {
      opacity: 1;
    }

    50% {
      opacity: 0.2;
    }

    100% {
      opacity: 1;
    }
  }
}

.recording-end-icon {
  overflow: hidden;
  cursor: pointer;
  font-size: 12px;
  width: 66px;
  border-radius: 14px;
  border: 1px solid #ff5c49;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ff5c49;
}

.record-icon {
  text-align: center;
  overflow: hidden;
  cursor: pointer;
  font-size: 12px;
  width: 66px;
  border-radius: 14px;
  border: 1px solid #acb2bf;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #dddddd;

  // img {
  // filter: drop-shadow(#acb2bf 80px 0);
  // -webkit-filter: drop-shadow(#acb2bf 80px 0);
  // transform: translateX(-80px);
  //   display: block;
  //   width: 16px;
  //   margin: 2.5px auto;
  // }
  .red-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #ff7257;
    margin-right: 4px;
  }
}

// .toollist-style1 {
// .toollist-icon {
//   // img {
//   //   filter: drop-shadow(#44454d 80px 0);
//   //   -webkit-filter: drop-shadow(#44454d 80px 0);
//   // }
// }
// .tool-name {
//   color: #44454d;
// }
// }
.enabled-record {
  .red-dot {
    background-color: #acb2bf;
  }
}

.red {
  color: #ff5f46;
}

.endBtn {
  width: 66px;
  height: 28px;
  background: linear-gradient(311deg, #ff5f46 0%, #ff4d5b 99%);
  border-radius: 14px;
  border: none;
  padding: 0;
}

.blueBtn {
  width: 66px;
  height: 28px;
  background: linear-gradient(120deg, #2466ff 0%, #03c4ff 100%);
  border-radius: 14px;
  padding: 0px;
  border: none;
}

.disabledBtn,
.toollist-disabled,
.enabled-record,
.enabled-start {
  cursor: default;
}

.toollist-disabled,
.enabled-record,
.enabled-start {
  opacity: 0.5;

  .tool-name,
  span {
    color: #727480;
  }
}

.lianmai-tips {
  position: absolute;
  top: -5px;
  right: 3px;
  font-size: 12px;
  color: $white-color;
  z-index: 100;
  display: inline-block;
  background: $red-color;
  min-width: 14px;
  height: 14px;
  line-height: 14px;
  border-radius: 7px;
}

.button-transparent {
  border: 1px solid #3986ee;
  color: #3986ee;
  padding: 5px 12px;
  border-radius: 4px;
  margin-right: 14px;
  cursor: pointer;
  font-size: 12px;

  &:hover {
    background-color: #3986ee;
    color: #fff;
  }
}

.el-icon-setting {
  font-size: 18px;
  color: #7d7f8c;
  margin-bottom: 30px;
}

.record-tips {
  position: absolute;
  width: 300px;
  padding: 15px;
  bottom: 80px;
  border-radius: 10px;
  background: #2d304f;
  color: rgba(255, 255, 255, 0.65);
  border: 1px solid #444767;
  // box-shadow: 0px 1px 3px 0px rgb(0 0 0 / 20%);
  z-index: 1000;
  left: 20px;
}

.end-record-tips {
  position: absolute;
  min-width: 150px;
  padding: 15px;
  bottom: 60px;
  border-radius: 6px;
  background: #2d304f;
  color: rgba(255, 255, 255, 0.65);
  border: 1px solid #444767;
  // box-shadow: 0px 1px 3px 0px rgb(0 0 0 / 20%);
  z-index: 1000;
  left: 20px;
}

[data-theme='Orange'] .end-record-tips {
  background: #fff;
  border: 0 none;
}

[data-theme='Orange'] .record-icon {
  color: #8a8f99;
}
</style>
